import { setApproverTab } from "../../state/slices/generalSlice";
import ApproveTRLocal from "./ApproveTRLocal";
import ApproveCos from "./ApproveCos";
import ApproveCwa from "./ApproveCwa";
import ApproveFsr from "./ApproveFsr";

import {
  CarFilled,
  CarryOutOutlined,
  FileDoneOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import TabSelection from "../../components/SelectContent/TabSelection";

const ApproverPage = () => {
  const menuItems = [
    {
      key: "tr-local",
      label: "Local Travel Request",
      abbre: "TR",
      component: <ApproveTRLocal />,
      icon: <CarFilled />,
    },
    {
      key: "cos",
      label: "Certificate of Service",
      abbre: "COS",
      component: <ApproveCos />,
      icon: <CarryOutOutlined />,
    },
    {
      key: "cwa",
      label: "Certificate of Work Accomplishment",
      abbre: "CWA",
      component: <ApproveCwa />,
      icon: <FileDoneOutlined />,
    },
    {
      key: "fsr",
      label: "Faculty Service Record",
      abbre: "FSR",
      component: <ApproveFsr />,
      icon: <FileTextOutlined />,
    },
  ];

  return (
    <>
      <TabSelection
        menuItems={menuItems}
        currentTabKey="approverCurrentTab"
        setTabAction={setApproverTab}
      />
    </>
  );
};

export default ApproverPage;
